import { useState } from 'react';

const useSwitch = () => {
    const [show, setShow] = useState(false);
    const [time] = useState(2000);
    const [message, setMessage] = useState('');
    const timeCallback = () => {
        setShow(false);
    };

    const type = 'tip';
    const [iconType, setIcon] = useState('error');

    const showSuccessTip = (msg) => {
        setShow(true);
        setIcon('success');
        if (msg) {
            setMessage(msg);
        }
    };

    const showErrorTip = (msg) => {
        setShow(true);
        setIcon('error');
        if (msg) {
            setMessage(msg);
        }
    };

    return {
        show,
        time,
        timeCallback,
        type,
        iconType,
        message,
        showSuccessTip,
        showErrorTip,
    };
};

export default useSwitch;
